<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span>{{ total }} Groupes</span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          v-if="canAddUsers"
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount"
          :to="{name: 'GroupCreate'}">
          <span class="icon is-medium"><i class="fas fa-plus-circle"></i></span><span>Créer Groupe</span>
        </router-link>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="false"
      :has-padd-right-normal="true">
      <tabs
        :links="groupTabLinks"
        :is-fullwidth="true"
        :level="1"
        :mode="'emitter'"
        @changeView="changeView"
        class="is-border-bottom is-margin-bottom"></tabs>
      <router-view
        :key="$route.name"></router-view>
    </page-content>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'GroupListVue',
  computed: {
    ...mapGetters(['canAddUsers']),
    groupTabLinks () {
      let tabs = []
      tabs.push({ link: 'GroupListInterne', name: 'interne', label: 'Utilisateur interne' })
      tabs.push({ link: 'GroupListExterne', name: 'externe', label: 'Utilisateur externe' })
      return tabs
    }
  },
  methods: {
    changeView (link) {
      this.$router.push({ name: link })
    }
  }
}
</script>
